import { ClientSettingsSchema, CustomerSettingsSchema, defaultClientSettings } from './settings';
import { SettingsApi } from './SettingsApi';
import { get } from 'svelte/store';
import { api, clientSettings, customerSettings } from '../../../stores/api';

export class SettingsManager {
    static updateCustomer() {
        try {
            CustomerSettingsSchema.parse(get(customerSettings));
            SettingsApi.setCustomerSettings(get(api), get(customerSettings));
        } catch (e: any) {
            console.error('settings store error', e);
            alert('settings store error');
            throw new Error('settings store error');
        }
    }

    static updateClient() {
        try {
            try {
                ClientSettingsSchema.parse(get(clientSettings));
            } catch (e: any) {
                console.error('settings store error', e);
                clientSettings.set({ ...defaultClientSettings });
                throw new Error('settings store error');
            }
            SettingsApi.setClientSettings(
                get(api),
                'settings',
                get(clientSettings),
                ClientSettingsSchema
            );
        } catch (e: any) {
            console.error('settings store error', e);
            alert('settings store error');
            throw new Error('settings store error');
        }
    }
}
